import { URL_REPLACEMENT } from '$const';
import { AssetId } from '~modules/media-library/model/Asset';
import { get } from '~services/api/methods';

export async function fetchCollection(idCollection: AssetId) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/collection_data/${idCollection}`;
  const response = await get(requestUrl);
  return response;
}
